<style lang="scss" scoped>
@import "core";

.my-body {
  margin-top: 5px;
}

.my-btn {
  margin: 5px;
  min-width: 120px;

  @include mq(xs) {
    width: 100%;
  }
}
</style>

<template>
<dn-dialog
  content-class="dn-confirm-dialog"
  :btn-close="false"
  @before-show="onBeforeShow"
  @before-hide="onBeforeHide"
  persistent
  ref="dialog"
  system
>
  <p v-if="body" v-html="bodyHtml" class="my-body"></p>

  <template slot="footer">
    <div class="my-btns">
      <dn-btn class="my-btn" @click="cancel" ref="cancel">{{cancelLabel}}</dn-btn>
      <dn-btn class="my-btn" @click="ok" ref="ok">{{okLabel}}</dn-btn>
    </div>
  </template>
</dn-dialog>
</template>



<script>
const DEFAULT_OPTIONS = {
  body  : null,
  ok    : 'OK',
  cancel: 'キャンセル',
};



export default {
  data() {
    return {
      body       : null,
      okLabel    : null,
      cancelLabel: null,
    }
  },



  computed: {
    dialog() { return this.$refs.dialog },
    bodyHtml() { return this.body && this.body.trim().replace(/\n/g, '<br>') },
  },



  methods: {
    reset() {
      if (this._resolver) {
        this._resolver();
        this._resolver = null;
        delete this._resolver;
      }
      this.body        = null;
      this.okLabel     = null;
      this.cancelLabel = null;
      this.removeEscKeyHandler();
    },
    show(opt = {}) {
      return new Promise(resolve => {
        this.reset();
        this._resolver = resolve;

        opt = typeof opt === 'string' ? {body: opt} : opt;
        opt = Object.assign({}, DEFAULT_OPTIONS, opt);

        this.body        = opt.body;
        this.okLabel     = opt.ok;
        this.cancelLabel = opt.cancel;
        return this.dialog.show();
      });
    },
    onBeforeShow() {
      this.addEscKeyHandler();
      this.$nextTick(() => {
        this.$refs.cancel.focus();
      });
    },
    onBeforeHide() {
      this.removeEscKeyHandler();
    },
    hide() { return this.dialog.hide() },

    resolve(value) {
      if (this._resolver) {
        this._resolver(value);
        this._resolver = null;
        delete this._resolver;
      }
    },
    ok() {
      this.resolve(true);
      this.hide();
    },
    cancel() {
      this.resolve(false);
      this.hide();
    },
    addEscKeyHandler() {
      if (this._escKeyHandler) return;
      this._escKeyHandler = e => {
        if (e.keyCode === 27) {
          this.cancel();
        }
      }
      document.addEventListener('keyup', this._escKeyHandler, false);
    },
    removeEscKeyHandler() {
      if (this._escKeyHandler) {
        document.removeEventListener('keyup', this._escKeyHandler);
        this._escKeyHandler = null;
        delete this._escKeyHandler;
      }
    },
  },

  beforeDestroy() {
    this.reset();
  },
}
</script>


// WEBPACK FOOTER //
// ConfirmDialog.vue?b1b72d3c